import { IClient } from '../../../shared/interfaces/clients/IClient';
import { IBaseModel } from '../../../shared/interfaces/shared/IBase';
import { IPagination } from '../../../shared/interfaces/shared/IPagination';
import { requests } from '../../../utils/api/api.service';
import { CLIENT_URL } from '../../../utils/api/endpoints';

export const AdminClientService = {
  get: (pagination: IPagination): Promise<IBaseModel<IClient[]>> =>
    requests.get(CLIENT_URL, pagination),
  getSingle: (id: number): Promise<IClient> =>
    requests.get(`${CLIENT_URL}/${id}`),
  create: (params: IClient) => requests.post(CLIENT_URL, params),
  update: (params: IClient, id: number) =>
    requests.put(`${CLIENT_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${CLIENT_URL}/${id}`),
};
